import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/share';

@Injectable()
export class SpinnerService {
  public status: Subject<boolean> = new Subject();
  private count: number = 0;

  public get active(): boolean {
    return this.count > 0;
  }

  public set active(v: boolean) {
    this.status.next(v);
  }

  public start(): void {
    this.count += 1;
    this.active = this.count > 0;
    
  }

  public stop(): void {
    this.count -= 1;
    if(this.count<0) this.count = 0;
    this.active = this.count > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/spinner.service.ts